
import db from './util.db';
import cookies from './util.cookies';
import Vue from 'vue';
import { Dialog } from 'vant';
import api from '../service/modules/refund'
import store from '../store'
Vue.use(Dialog);

const callConfirm = function (title, phone, operatingType) {
    Dialog.confirm({
        title: title || '是否拨打退货人号码',
        message: phone,
        confirmButtonColor: '#37b375'
    })
        .then(() => {
            const param = {
                baseId: store.state.refund.detail.detail.basicId,
                operatingType
            }
            api.saveOperatingRecord(param)
            // on confirm
            const callEle = document.createElement('a')
            let tel = 'tel:'+phone
            console.log(tel)
            callEle.href = tel
            callEle.click()
        })
        .catch(() => {
            // on cancel
        })
}
const util = {
    db,
    cookies,
    callConfirm
};

export default util;
